/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HotelEditSingleNetActiveApiRequest } from '../../models/hotel-edit-single-net-active-api-request';

export interface ApiHotelManageEditSingleNetActivePost$Params {
      body: HotelEditSingleNetActiveApiRequest
}

export function apiHotelManageEditSingleNetActivePost(http: HttpClient, rootUrl: string, params: ApiHotelManageEditSingleNetActivePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelManageEditSingleNetActivePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelManageEditSingleNetActivePost.PATH = '/api/hotel/manage/edit/single/net-active';
